import powerpoint from '@/assets/images/ds-logos/microsoft-powerpoint.svg'
import excel from '@/assets/images/ds-logos/microsoft-excel.svg'
import word from '@/assets/images/ds-logos/microsoft-word.svg'
import pdf from '@/assets/images/ds-logos/pdf.svg'
import googleSlides from '@/assets/images/ds-logos/google-slides.svg'
import googleDrive from '@/assets/images/ds-logos/google-drive.svg'
import oneDrive from '@/assets/images/ds-logos/microsoft-onedrive.svg'
import claude from '@/assets/images/ds-logos/claude.svg'
import chatgpt from '@/assets/images/ds-logos/chatgpt.png'

export const DS_LOGOS = {
  powerpoint,
  excel,
  word,
  pdf,
  googleSlides,
  googleDrive,
  oneDrive,
  claude,
  chatgpt,
}

const DS_LINE_LOGO_BASE = 'https://design.ahaslides.io/logo/line'

export const DS_LINE_LOGOS = {
  googleDrive: `${DS_LINE_LOGO_BASE}/google-drive.svg`,
  oneDrive: `${DS_LINE_LOGO_BASE}/microsoft-onedrive.svg`,
}
